document.addEventListener('DOMContentLoaded', function () {

  // Check if an element is in the viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.8 &&
      rect.bottom >= 0
    );
  }

  let elementsVisible = [];

  const percentageElements = document.querySelectorAll('.clinical-stat-block .stat-percentage');

  const targetValues = [];

  percentageElements.forEach((element, index) => {
    const originalText = element.textContent.trim();

    // Skip animation for values like "1 in 5"
    if (/^\d+\s+in\s+\d+$/i.test(originalText)) {
      targetValues.push({
        animate: false,
        original: originalText
      });

      elementsVisible.push(false);
      return;
    }

    // Extract the numeric value and suffix
    const match = originalText.match(/([0-9.]+)\s*(.*)/);

    targetValues.push({
      animate: true,
      value: match ? parseFloat(match[1]) : 0,
      suffix: match ? match[2] : ''
    });

    // Set initial value to 0
    element.textContent = '0' + (match ? match[2] : '');

    elementsVisible.push(false);
  });

  function animatePercentages() {
    percentageElements.forEach((element, index) => {

      const isCurrentlyVisible = isInViewport(element);

      if (isCurrentlyVisible && !elementsVisible[index]) {

        elementsVisible[index] = true;

        const target = targetValues[index];

        // Don't animate "1 in 5"
        if (!target.animate) {
          element.textContent = target.original;
          return;
        }

        let currentValue = 0;
        const duration = 2000;
        const interval = 20;
        const increment = target.value / (duration / interval);

        element.textContent = '0' + target.suffix;

        const animation = setInterval(() => {

          currentValue += increment;

          if (currentValue >= target.value) {
            currentValue = target.value;
            clearInterval(animation);

            if (String(target.value).includes('.')) {
              element.textContent = target.value + target.suffix;
            } else {
              element.textContent = Math.round(target.value) + ' ' + target.suffix;
            }

          } else {

            if (String(target.value).includes('.')) {
              element.textContent = currentValue.toFixed(1) + target.suffix;
            } else {
              element.textContent = Math.round(currentValue) + ' ' + target.suffix;
            }

          }

        }, interval);

      } else if (!isCurrentlyVisible && elementsVisible[index]) {

        elementsVisible[index] = false;

      }

    });
  }

  window.addEventListener('scroll', animatePercentages);

  animatePercentages();

});